import React from "react";
// reactstrap components
import {
  Carousel,

  CarouselIndicators, CarouselItem, Col, Container,
  Row
} from "reactstrap";


// core components

const items = [
  {
    src: require("assets/img/products/persimmon/prod_30000_small.jpg"),
    altText: "선물용 시례골 곶감(소)",
    caption: "선물용 시례골 곶감(소)"
  },
  {
    src: require("assets/img/products/persimmon/prod_45000_medium.jpg"),
    altText: "선물용 시례골 곶감(중)",
    caption: "선물용 시례골 곶감(중)"
  },
  {
    src: require("assets/img/products/persimmon/prod_70000_3.jpg"),
    altText: "선물용 시례골 곶감(특중)",
    caption: "선물용 시례골 곶감(특중)"
  },
  {
    src: require("assets/img/products/persimmon/prod_10000_snack.jpg"),
    altText: "간식용 감말랭이",
    caption: "간식용 감말랭이"
  },
  {
    src: require("assets/img/products/persimmon/prod_15000_snack.jpg"),
    altText: "간식용 곶감",
    caption: "간식용 곶감"
  }
];

function CarouselSection() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <div className="section" id="carousel">
        <Container>
          <div className="title">
          </div>
          <Row className="justify-content-center">
            <Col lg="8" md="12">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {items.map(item => {
                  return (
                    <CarouselItem
                      onExiting={onExiting}
                      onExited={onExited}
                      key={item.src}
                    >
                      <img src={item.src} alt={item.altText} />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>{item.caption}</h5>
                      </div>
                    </CarouselItem>
                  );
                })}
                <a
                  className="carousel-control-prev"
                  data-slide="prev"
                  href="#pablo"
                  onClick={e => {
                    e.preventDefault();
                    previous();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-left"></i>
                </a>
                <a
                  className="carousel-control-next"
                  data-slide="next"
                  href="#pablo"
                  onClick={e => {
                    e.preventDefault();
                    next();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-right"></i>
                </a>
              </Carousel>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CarouselSection;
